const navigationTabs = {
    dashboard: {
        seller: "seller",
        buyer: "buyer",
    },
    seller: {
        debtors: {
            overview: "overview"
        },
        upload: {
            upload: "upload",
            new: "new",
            waiting: "waiting",
            rejected: "rejected",
            receivables: "receivables",
        },
        sell: {
            approved: "approved",
            selling: "selling",
            payments: "payments",
            receivables: "receivables",
            investors: "investors"
        },
        putOptions: {
            requests: "requests",
            active: "active",
            contracts: "contracts"
        },
        trackPay: {
            contracts: "contracts",
            settled: "settled",
        }
    },
    investor: {
        exchange: {
            receivables: "receivables",
            putOptions: "putOptions",
        },
        payments: {
            receivables: "receivables",
            putOptions: "putOptions",
        },
        investments: {
            receivables: "receivables",
            putOptions: "putOptions",
        },
        ratings: {
            custom: "custom",
        }
    },
    debtor: {
        ipu: "ipu",
        trackPay: {
            contracts: "contracts"
        }
    },
    admin: {
        profile: {
            info: "info",
            apiKeys: "apiKeys"
        },
        company: {
            info: "info",
            cofaceToS: "cofaceToS",
            putOptionToS: "putOptionToS",
            tciActivation: "tciActivation"
        }
    }
};

export {
    navigationTabs
};